import { render, staticRenderFns } from "./myCards.vue?vue&type=template&id=4062423c&scoped=true&"
import script from "./myCards.vue?vue&type=script&lang=js&"
export * from "./myCards.vue?vue&type=script&lang=js&"
import style0 from "./myCards.vue?vue&type=style&index=0&id=4062423c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4062423c",
  null
  
)

export default component.exports